const useKeyCap = () => {
  const onEnter = (callBack: Function) => (e: any) => {
    if (callBack && e.key === "Enter") {
      callBack(e);
    }
  };

  const onBackspace = (callBack: Function) => (e: any) => {
    if (callBack && e.key === "Backspace") {
      callBack(e);
    }
  };

  const onArrowLeft = (callBack: Function) => (e: any) => {
    if (callBack && e.key === "ArrowLeft") {
      callBack(e);
    }
  };

  const onArrowRight = (callBack: Function) => (e: any) => {
    if (callBack && e.key === "ArrowRight") {
      callBack(e);
    }
  };

  const onNumberOnly = (callBack: Function) => (e: any) => {
    if (callBack && /[0-9]/.test(e.key)) {
      callBack(e);
    }
  };

  return { onEnter, onBackspace, onArrowLeft, onArrowRight, onNumberOnly };
};

export default useKeyCap;
